import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ADD_ADDITIONAL_FTTB_TV_CONSOLE, ADD_FTTB_TV_CONSOLE_FOR_CHANGE, EXCLUDE_PRE_ENABLED_FTTB_TV_CONSOLE, REMOVE_ADDITIONAL_FTTB_TV_CONSOLE, REMOVE_ALL_FTTB_TV_CONSOLE_FOR_CHANGE, REMOVE_FTTB_TV_CONSOLE_FOR_CHANGE, RETURN_ALL_PRE_ENABLED_FTTB_TV_CONSOLE } from "../actions/actionTypes";
var reducers = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ADD_FTTB_TV_CONSOLE_FOR_CHANGE, function (state, _ref) {
  var tvConsole = _ref.tvConsole;
  var tvConsolesForChange = state.fttbSelectedTvConsoles.forChange || [];
  if (tvConsolesForChange.find(function (tv) {
    return tv.alias === tvConsole.alias;
  })) return state;
  var newTvConsole = {
    name: tvConsole.name,
    alias: tvConsole.alias,
    fee: Number(tvConsole.price.value),
    unit: tvConsole.price.unit,
    isAndroidTv: tvConsole.isAndroidTv
  };
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSelectedTvConsoles: _objectSpread(_objectSpread({}, state.fttbSelectedTvConsoles), {}, {
      forChange: [].concat(_toConsumableArray(tvConsolesForChange), [newTvConsole])
    })
  });
}), REMOVE_FTTB_TV_CONSOLE_FOR_CHANGE, function (state, _ref2) {
  var alias = _ref2.alias;
  var tvConsolesForChange = state.fttbSelectedTvConsoles.forChange || [];
  var filtredTvConsolesForChange = tvConsolesForChange.filter(function (tv) {
    return tv.alias !== alias;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSelectedTvConsoles: _objectSpread(_objectSpread({}, state.fttbSelectedTvConsoles), {}, {
      forChange: filtredTvConsolesForChange
    })
  });
}), REMOVE_ALL_FTTB_TV_CONSOLE_FOR_CHANGE, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSelectedTvConsoles: _objectSpread(_objectSpread({}, state.fttbSelectedTvConsoles), {}, {
      forChange: []
    })
  });
}), ADD_ADDITIONAL_FTTB_TV_CONSOLE, function (state, _ref3) {
  var tvConsole = _ref3.tvConsole;
  var additionalTvConsoles = state.fttbSelectedTvConsoles.additional || [];
  if (additionalTvConsoles.find(function (tv) {
    return tv.alias === tvConsole.alias;
  })) return state;
  var newTvConsole = {
    name: tvConsole.name,
    alias: tvConsole.alias,
    fee: Number(tvConsole.price.value),
    unit: tvConsole.price.unit,
    isAndroidTv: tvConsole.isAndroidTv
  };
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSelectedTvConsoles: _objectSpread(_objectSpread({}, state.fttbSelectedTvConsoles), {}, {
      additional: [].concat(_toConsumableArray(additionalTvConsoles), [newTvConsole])
    })
  });
}), REMOVE_ADDITIONAL_FTTB_TV_CONSOLE, function (state, _ref4) {
  var alias = _ref4.alias;
  var additionalTvConsoles = state.fttbSelectedTvConsoles.additional || [];
  var filtredAdditionalTvConsoles = additionalTvConsoles.filter(function (tv) {
    return tv.alias !== alias;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSelectedTvConsoles: _objectSpread(_objectSpread({}, state.fttbSelectedTvConsoles), {}, {
      additional: filtredAdditionalTvConsoles
    })
  });
}), EXCLUDE_PRE_ENABLED_FTTB_TV_CONSOLE, function (state, _ref5) {
  var tvConsole = _ref5.tvConsole;
  var excluded = state.fttbSelectedTvConsoles.excluded || [];
  if (excluded.find(function (tv) {
    return tv.alias === tvConsole.alias;
  })) return state;
  var newTvConsole = {
    name: tvConsole.name,
    alias: tvConsole.alias,
    fee: Number(tvConsole.price.value),
    unit: tvConsole.price.unit
  };
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSelectedTvConsoles: _objectSpread(_objectSpread({}, state.fttbSelectedTvConsoles), {}, {
      excluded: [].concat(_toConsumableArray(excluded), [newTvConsole])
    })
  });
}), RETURN_ALL_PRE_ENABLED_FTTB_TV_CONSOLE, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    fttbSelectedTvConsoles: _objectSpread(_objectSpread({}, state.fttbSelectedTvConsoles), {}, {
      excluded: []
    })
  });
});
export var fttbTvConsoles = function fttbTvConsoles(state, action) {
  var reducer = reducers[action.type];
  return typeof reducer === 'function' ? reducer(state, action.payload) : state;
};